import React from 'react';
import { Box, HelpIcon, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

import theme from '@/styles/theme';

interface Props {
  question: string;
  index: number;
  onQuestionClick?: () => void;
}

const FAQStyledBox = styled(Box)`
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    span {
      color: ${theme.colors.textAccentHover};
    }
    svg {
      fill: ${theme.colors.textAccentHover};
    }
  }
`;

const RenewalFAQItem: React.FC<Props> = ({ question, index, onQuestionClick }) => {
  return (
    <FAQStyledBox
      data-testid={`renewal-faq-item-${index}`}
      onClick={onQuestionClick}
      round="container1Round"
      background="canvas"
      direction="row"
      align="center"
      gap="xxs"
    >
      <HelpIcon size="18px" color="textTitle" />
      <Inscription color="textTitle">{question}</Inscription>
    </FAQStyledBox>
  );
};

export default RenewalFAQItem;
